import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/decoration`;

interface Props {
    className?: string;
}

export const DecorationInner: FC<Props> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            プチデコレーション
        </Title>
        <Image src={`${IMG_PATH}/decoration.png`} />

        <Paragraph>
            矧ぎ糸部分に花や蝶の柄をのせて華やかさをプラスすることができます。
            走り羽に合わせて加工するので矢つがえの際のちょっとした目印にもなります。
        </Paragraph>

        <Paragraph>
            ※「糸・和紙」で「和紙」をお選びの場合、プチデコレーションはお選びいただけません。
            ※配置・デザインは全ての矢が画像と同じという事ではございません。
            画像とパーツの配置が異なる場合がございます。ご了承の程よろしくお願い申し上げます。
        </Paragraph>
    </OrderPartsHelpContents>
);

export const OrderPartsHelpDecoration: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <DecorationInner />
            </div>
        </div>
    </Panel>
);
